module.exports = __webpack_public_path__ + "img/icon-relations.a665f4cd.svg";